import { BadgeStyled, CardContentStyled } from '@procurify/ui'
import styled from 'styled-components'

import { type IInboxListProps } from '../InboxList'

export const InboxListStyled = styled.div<Partial<IInboxListProps>>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .logo-bullet {
    width: ${(props) => props.theme.typography.pxToRem(31)};
    height: ${(props) => props.theme.typography.pxToRem(31)};

    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
    }
  }

  ${CardContentStyled} {
    overflow-y: auto;
    padding: ${(props) => props.theme.space.medium};

    ${CardContentStyled} {
      padding: ${(props) => props.theme.space.small};
    }
  }

  ${BadgeStyled} {
    padding: 0;
    background-color: ${(props) => props.theme.colors.secondary};
  }
`
